"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const reduxHooks_1 = require("src/hooks/reduxHooks");
const AppNavHeader_1 = __importDefault(require("src/components/organisms/AppNavHeader"));
const FilterDateRange_1 = __importDefault(require("src/components/organisms/FilterDateRange"));
const clients_module_css_1 = __importDefault(require("../clients/styles/clients.module.css"));
const selectors_1 = require("src/stores/applicationStore/stat/selectors");
const selectors_2 = require("src/stores/applicationStore/tours/selectors");
const actions_1 = require("src/stores/applicationStore/stat/actions");
const thunks_1 = require("src/stores/applicationStore/stat/thunks");
const StatTour_1 = __importDefault(require("./StatTour"));
const StatUsers_1 = __importDefault(require("./StatUsers"));
const StatUsersConversion_1 = __importDefault(require("./StatUsersConversion"));
const Stat = () => {
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const data = (0, reduxHooks_1.useAppSelector)(selectors_1.selectStat);
    const tours = (0, reduxHooks_1.useAppSelector)(selectors_2.selectTours);
    (0, react_1.useEffect)(() => {
        if (!!data.filter.date_from) {
            dispatch((0, thunks_1.fetchStatBaseThunk)({
                date_from: data.filter.date_from,
                date_to: data.filter.date_to,
                period: data.filter.period,
            }));
            dispatch((0, thunks_1.fetchStatCohortPaycvThunk)({
                date_from: data.filter.date_from,
                date_to: data.filter.date_to,
            }));
            dispatch((0, thunks_1.fetchStatTourViewThunk)({
                date_from: data.filter.date_from,
                date_to: data.filter.date_to,
            }));
        }
    }, [data.filter.date_from, data.filter.date_to, data.filter.period]);
    (0, react_1.useEffect)(() => {
        if (!!data.filter.date_from && data.filter.tour) {
            dispatch((0, thunks_1.fetchStatTourStepsViewThunk)({
                date_from: data.filter.date_from,
                date_to: data.filter.date_to,
                tour: data.filter.tour,
                finished: data.filter.finished,
            }));
        }
    }, [data.filter.date_from, data.filter.date_to, data.filter.period, data.filter.tour, data.filter.finished]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: clients_module_css_1.default.container }, { children: [(0, jsx_runtime_1.jsx)(AppNavHeader_1.default, { title: i18n_1.default.t("labeled_section")["statistics"] }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: clients_module_css_1.default.content }, { children: [(0, jsx_runtime_1.jsx)(FilterDateRange_1.default, { from: data.filter.date_from, to: data.filter.date_to, defaultPeriod: data.filter.period, onChange: (period, from, to) => {
                            dispatch((0, actions_1.updateStatFilters)({
                                period: period,
                                date_from: from.format("YYYY-MM-DD"),
                                date_to: to.format("YYYY-MM-DD"),
                            }));
                        }, yesterday: false, date_range_off: true }), (0, jsx_runtime_1.jsx)(StatUsers_1.default, { data: data }), !!tours && (0, jsx_runtime_1.jsx)(StatTour_1.default, { data: data }), (0, jsx_runtime_1.jsx)(StatUsersConversion_1.default, { data: data })] }))] })));
};
exports.default = Stat;
